import { Control } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../../../ui/components/ui/form';
import { Input } from '../../../../ui/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../ui/components/ui/select';
import { countries } from '../../../organisations/root/forms/items/personal-form-items';
import { FIELD_LABEL_CLASS } from '../../constants/offer-checkout.constants';
import { OfferCheckoutFormValues } from '../offer-checkout-form/offer-checkout-form.schema';

type TextField = 'firstName' | 'lastName' | 'name' | 'vatId' | 'street' | 'houseNumber' | 'postCode' | 'city';

const TextInputField = ({
  control,
  name,
  label,
  className
}: {
  control: Control<OfferCheckoutFormValues>;
  name: TextField;
  label: string;
  className?: string;
}) => (
  <FormField
    control={control}
    name={name}
    render={({ field }) => (
      <FormItem className={className}>
        <FormLabel className={FIELD_LABEL_CLASS}>{label}</FormLabel>
        <FormControl>
          <Input {...field} className="bg-white" />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

/** Inputs of the "Daten" section – same fields as the self-checkout and the organization. */
const CustomerDataFields = ({ control }: { control: Control<OfferCheckoutFormValues> }) => (
  <div className="grid grid-cols-2 gap-3">
    <TextInputField control={control} name="firstName" label="Vorname" />
    <TextInputField control={control} name="lastName" label="Nachname" />
    <TextInputField control={control} name="name" label="Firma" className="col-span-2" />
    <TextInputField control={control} name="vatId" label="USt-ID" className="col-span-2" />
    <TextInputField control={control} name="street" label="Straße" />
    <TextInputField control={control} name="houseNumber" label="Hausnr." />
    <TextInputField control={control} name="postCode" label="PLZ" />
    <TextInputField control={control} name="city" label="Ort" />
    <FormField
      control={control}
      name="country"
      render={({ field }) => (
        <FormItem className="col-span-2">
          <FormLabel className={FIELD_LABEL_CLASS}>Land</FormLabel>
          <Select value={field.value} onValueChange={field.onChange}>
            <FormControl>
              <SelectTrigger ref={field.ref} className="bg-white">
                <SelectValue placeholder="Land auswählen" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {countries.map((country) => (
                <SelectItem key={country.value} value={country.value}>
                  {country.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  </div>
);

export default CustomerDataFields;
